export const baseURL = process.env.REACT_APP_BASE_URL;
export const secretKey = process.env.REACT_APP_SECRET_KEY;

export const agoraId = process.env.REACT_APP_AGORA_ID;

// Subdomain routing - editable via .env
export const subdomainAdmin = process.env.REACT_APP_SUBDOMAIN_ADMIN || "admin";
export const subdomainContentCreator = process.env.REACT_APP_SUBDOMAIN_CONTENT_CREATOR || "content-creator";
